import { useQuery } from '@apollo/client/react'
import { GET_GBP_REVIEWS } from '@/lib/operations/dashboard'
import type { GbpReviewSummary } from '@/lib/types'

export function useGbpReviews(clientId: string | null, locationId?: string | null) {
  const { data, loading, error } = useQuery<{ gbpReviews: GbpReviewSummary | null }>(GET_GBP_REVIEWS, {
    variables: { clientId, locationId: locationId ?? null },
    skip: !clientId,
  })
  return { reviews: data?.gbpReviews ?? null, loading, error }
}
